import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { useParams } from "react-router-dom";

import { inviteUser as inviteUserAPI } from "api/users";
import { usersKeys } from "api/users/queries";
import { NewUserPayloadType } from "api/users/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import UserForm, { UserFormValues } from "./UserForm";

// LOGIC:

// TYPES:

interface NewUserModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const NewUserModal = ({ isOpen, handleClose }: NewUserModalProps) => {
  const { organisationId } = useParams<{ organisationId: string }>();

  const queryClient = useQueryClient();

  const { mutateAsync: inviteUser, status } = useMutation(
    async (data: NewUserPayloadType) => {
      const res = await inviteUserAPI(data);
      await queryClient.invalidateQueries(usersKeys.list());
      return res.data;
    },
  );

  const handleSubmit = async (values: UserFormValues) => {
    await inviteUser(values, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="New User"
        subtitle="Invite a new user to this organisation."
      />
      <UserForm
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        initialValues={{
          organisation: organisationId ?? "",
          email: "",
          role: null,
        }}
      />
    </AppDialog>
  );
};

export default NewUserModal;
